export default __webpack_public_path__ + "static/sdk-illustration-25352f68d3cd97d4e736524569dfb961.svg";